export const scanConfigs = {
  collectArtifacts: {
    tabs: [
      {
        id: "1",
        title: "Collect Artifacts",
        fields: [
          { id: "Name", label: "Organization", type: "text", placeholder: "Enter Name", required: true },
          { id: "Description", label: "Description", type: "textarea", placeholder: "Enter Description", height: "100px" },
          { id: "target", label: "Domain", type: "textarea", placeholder: "Enter Domain" },
          {
            id: "scanType",
            label: "Scan Type",
            type: "select",
            options: [
              { value: "full", label: "Full Scan" },
              { value: "quick", label: "Quick Scan" },
            ],
          },
        ],
      },
      {
        id: "2",
        title: "Manual Upload",
        fields: [
          { id: "uploadFile", label: "Upload File", type: "file", placeholder: "Upload File" },
          { id: "uploadDirectory", label: "Upload Directory", type: "file", placeholder: "Upload Directory" },
        ],
      }
    ],
  },
  soc2: {
    tabs: [
      {
        id: "1",
        title: "SOC 2 Compliance",
        fields: [
          { id: "Name", label: "Organization", type: "text", placeholder: "Enter Name", required: true },
          { id: "Description", label: "Description", type: "textarea", placeholder: "Enter Description", height: "100px" },
          { id: "target", label: "Domain", type: "textarea", placeholder: "Enter Domain" },
          {
            id: "scanType",
            label: "Scan Type",
            type: "select",
            options: [
              { value: "full", label: "Full Scan" },
              { value: "quick", label: "Quick Scan" },
            ],
          },
        ],
      },
    ],
  },
  gdpr: {
    tabs: [
      {
        id: "1",
        title: "GDPR Compliance",
        fields: [
          { id: "Name", label: "Organization", type: "text", placeholder: "Enter Name", required: true },
          { id: "Description", label: "Description", type: "textarea", placeholder: "Enter Description", height: "100px" },
          { id: "target", label: "Domain", type: "textarea", placeholder: "Enter Domain" },
          {
            id: "scanType",
            label: "Scan Type",
            type: "select",
            options: [
              { value: "full", label: "Full Scan" },
              { value: "quick", label: "Quick Scan" },
            ],
          },
        ],
      },
    ],
  },
  sbomCompliance: {
    tabs: [
      {
        id: "1",
        title: "SBOM Compliance",
        fields: [
          { id: "Name", label: "Organization", type: "text", placeholder: "Enter Name", required: true },
          { id: "Description", label: "Description", type: "textarea", placeholder: "Enter Description", height: "100px" },
          { id: "sbomFormat", label: "SBOM Format", type: "select", options: [
            { value: "spdx", label: "SPDX" },
            { value: "cyclonedx", label: "CycloneDX" },
            { value: "custom", label: "Custom" },
          ] },
          {
            id: "sbomFile",
            label: "Upload SBOM File",
            type: "file",
            placeholder: "Upload SBOM file (e.g., SPDX, CycloneDX)",
            accept: ".json,.xml,.spdx,.cdx,.spdx.json,.cdx.json",
          },
          { id: "sbomVersion", label: "SBOM Version", type: "text", placeholder: "Enter SBOM Version" },
        ],
      },
      {
        id: "2",
        title: "Advanced Settings",
        fields: [
          { id: "sbomValidate", label: "Validate SBOM", type: "checkbox", options: [
            { value: "enabled", label: "Enabled" },
            { value: "disabled", label: "Disabled" },
          ] },
          { id: "sbomIncludeDevDependencies", label: "Include Dev Dependencies", type: "checkbox", options: [
            { value: "yes", label: "Yes" },
            { value: "no", label: "No" },
          ] },
        ],
      },
    ],
  },
  scaCompliance: {
    tabs: [
      {
        id: "1",
        title: "SCA Compliance",
        fields: [
          { id: "scaTool", label: "SCA Tool", type: "text", placeholder: "Enter SCA Tool (e.g., Snyk, WhiteSource)" },
          { id: "scaReport", label: "SCA Vulnerability Report", type: "file", placeholder: "Upload SCA Report" },
          { id: "scaLicenses", label: "License Compliance", type: "checkbox", options: [
            { value: "compliant", label: "Compliant" },
            { value: "non-compliant", label: "Non-Compliant" },
          ] },
        ],
      },
      {
        id: "2",
        title: "Advanced Settings",
        fields: [
          { id: "scaSeverity", label: "Severity Level", type: "select", options: [
            { value: "critical", label: "Critical" },
            { value: "high", label: "High" },
            { value: "medium", label: "Medium" },
            { value: "low", label: "Low" },
          ] },
          { id: "scaAutoFix", label: "Enable Auto-Fix", type: "checkbox", options: [
            { value: "enabled", label: "Enabled" },
            { value: "disabled", label: "Disabled" },
          ] },
        ],
      },
    ],
  },
  iso27001: {
    tabs: [
      {
        id: "1",
        title: "ISO 27001 Compliance",
        fields: [
          { id: "Name", label: "Organization", type: "text", placeholder: "Enter Name", required: true },
          { id: "Description", label: "Description", type: "textarea", placeholder: "Enter Description", height: "100px" },
          { id: "target", label: "Domain", type: "textarea", placeholder: "Enter Domain" },
          {
            id: "scanType",
            label: "Scan Type",
            type: "select",
            options: [
              { value: "full", label: "Full Scan" },
              { value: "quick", label: "Quick Scan" },
            ],
          },
        ],
      },
    ],
  },
  hipaa: {
    tabs: [
      {
        id: "1",
        title: "HIPAA Compliance",
        fields: [
          { id: "Name", label: "Organization", type: "text", placeholder: "Enter Name", required: true },
          { id: "Description", label: "Description", type: "textarea", placeholder: "Enter Description", height: "100px" },
          { id: "target", label: "Domain", type: "textarea", placeholder: "Enter Domain" },
          {
            id: "scanType",
            label: "Scan Type",
            type: "select",
            options: [
              { value: "full", label: "Full Scan" },
              { value: "quick", label: "Quick Scan" },
            ],
          },
        ],
      },
    ],
  },
};
